import React from 'react';
import { APPLE_THEME, TYPOGRAPHY } from '../theme';

const Icon = ({ type, size = 24, color = APPLE_THEME.metalicGray }) => {
  const common = { fill: 'none', stroke: color, strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden>
      {type === 'tools' && (
        <g {...common}>
          <path d="M14.7 6.3a4 4 0 0 1 5 5L14 5.6" />
          <path d="M2 22l6-6" />
          <path d="M3 16l5 5" />
        </g>
      )}
      {type === 'calendar' && (
        <g {...common}>
          <rect x="3" y="4" width="18" height="18" rx="2" />
          <path d="M16 2v4M8 2v4M3 10h18" />
        </g>
      )}
      {type === 'faq' && (
        <g {...common}>
          <path d="M9 9a3 3 0 0 1 6 0c0 2-3 2-3 4" />
          <path d="M12 17h.01" />
          <rect x="3" y="3" width="18" height="18" rx="2" />
        </g>
      )}
      {type === 'shield' && (
        <g {...common}>
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </g>
      )}
      {type === 'remote' && (
        <g {...common}>
          <rect x="8" y="2" width="8" height="20" rx="2" />
          <circle cx="12" cy="7" r="1" />
          <path d="M10 12h4M10 15h4" />
        </g>
      )}
      {type === 'contact' && (
        <g {...common}>
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.09 4.2 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.06.67.2 1.34.41 1.98a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.64.21 1.31.35 1.98.41A2 2 0 0 1 22 16.92z" />
        </g>
      )}
    </svg>
  );
};

const Card = ({ icon, title, description, onClick, href }) => {
  const Wrapper = ({ children }) => href ? (
    <a href={href} style={{ textDecoration: 'none' }}>{children}</a>
  ) : (
    <button onClick={onClick} style={{ background: 'transparent', border: 'none', textAlign: 'left', padding: 0, cursor: 'pointer' }}>{children}</button>
  );

  return (
    <Wrapper>
      <div
        style={{
          background: APPLE_THEME.white,
          border: `1px solid ${APPLE_THEME.lightMetalicGray}`,
          borderRadius: '16px',
          padding: '20px',
          transition: 'box-shadow 200ms ease, transform 200ms ease'
        }}
        onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.08)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
        onMouseLeave={(e) => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'translateY(0)'; }}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
          <div
            style={{
              width: '44px', height: '44px', borderRadius: '12px',
              background: APPLE_THEME.lightMetalicGray,
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}
          >
            <Icon type={icon} size={22} color={APPLE_THEME.darkMetalicGray} />
          </div>
          <div>
            <div style={{ color: APPLE_THEME.black, fontFamily: TYPOGRAPHY.hero, fontSize: '18px', fontWeight: 600, marginBottom: '6px' }}>
              {title}
            </div>
            <div style={{ color: APPLE_THEME.textGray, fontFamily: TYPOGRAPHY.body, fontSize: '14px', lineHeight: 1.5 }}>
              {description}
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

const Support = () => {
  const navigateTo = (path) => {
    window.location.assign(path);
  };

  const cards = [
    {
      icon: 'tools',
      title: 'Onarım ve Hizmetler',
      description: 'Telefon, tablet ve ekran değişimi gibi hizmetlere göz atın.',
  onClick: () => navigateTo('/hizmetler')
    },
    {
      icon: 'calendar',
      title: 'Randevu Alın',
      description: 'Mağazamızdan hızlıca randevu talep edin.',
      href: 'tel:+905382477373'
    },
    {
      icon: 'faq',
      title: 'Sık Sorulan Sorular',
      description: 'Destek öncesi pratik cevapları inceleyin.',
  onClick: () => navigateTo('/destek#support-faq')
    },
    {
      icon: 'shield',
      title: 'Garanti ve Belgeler',
      description: 'Garanti kapsamı ve gerekli belgeler hakkında bilgi.',
  onClick: () => navigateTo('/destek#support-warranty')
    },
    {
      icon: 'remote',
      title: 'Uzaktan Destek',
      description: 'Küçük sorunlar için uzaktan yönlendirme.',
      href: 'https://wa.me/+905382477373'
    },
    {
      icon: 'contact',
  title: 'Hemen Ulaşın',
  description: 'Telefon ya da WhatsApp ile hızlıca ulaşın.',
  onClick: () => navigateTo('/iletisim')
    }
  ];

  return (
    <section id="support" style={{ background: APPLE_THEME.backgroundGray, padding: '70px 0 90px 0' }}>
      <div style={{ maxWidth: '980px', margin: '0 auto', padding: '0 20px' }}>
        <div style={{ textAlign: 'center', marginBottom: '36px' }}>
          <h2
            style={{
              color: APPLE_THEME.black,
              fontFamily: TYPOGRAPHY.hero,
              fontSize: 'clamp(28px, 4vw, 40px)',
              fontWeight: 700,
              letterSpacing: '-0.01em',
              marginBottom: '10px'
            }}
          >
            Destek Merkezi
          </h2>
          <p style={{ color: APPLE_THEME.metalicGray, fontFamily: TYPOGRAPHY.body, fontSize: '16px' }}>
            Sorununuzu birlikte çözelim. Başlamak için bir konu seçin.
          </p>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
            gap: '16px',
            marginBottom: '30px'
          }}
        >
          {cards.map((c, i) => (
            <Card key={i} icon={c.icon} title={c.title} description={c.description} onClick={c.onClick} href={c.href} />
          ))}
        </div>

        <div id="support-warranty" style={{ background: APPLE_THEME.white, border: `1px solid ${APPLE_THEME.lightMetalicGray}`, borderRadius: '16px', padding: '20px', marginBottom: '16px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
            <Icon type="shield" />
            <h3 style={{ color: APPLE_THEME.black, fontFamily: TYPOGRAPHY.hero, fontSize: '18px', fontWeight: 600 }}>Garanti kapsamı</h3>
          </div>
          <p style={{ color: APPLE_THEME.textGray, fontFamily: TYPOGRAPHY.body, fontSize: '15px', lineHeight: 1.5 }}>
            Onarımlarımız parça ve işçilik garantisiyle desteklenir. Garanti koşulları cihaz ve hizmet türüne göre değişebilir. Detay için bizimle iletişime geçin.
          </p>
        </div>

        <div id="support-faq" style={{ background: APPLE_THEME.white, border: `1px solid ${APPLE_THEME.lightMetalicGray}`, borderRadius: '16px', padding: '20px' }}>
          <h3 style={{ color: APPLE_THEME.black, fontFamily: TYPOGRAPHY.hero, fontSize: '18px', fontWeight: 600, marginBottom: '10px' }}>Sık Sorulan Sorular</h3>
          <details style={{ padding: '10px 0', borderTop: `1px solid ${APPLE_THEME.lightMetalicGray}` }}>
            <summary style={{ cursor: 'pointer', color: APPLE_THEME.black, fontFamily: TYPOGRAPHY.hero, fontSize: '16px' }}>Onarım ne kadar sürer?</summary>
            <p style={{ color: APPLE_THEME.textGray, fontFamily: TYPOGRAPHY.body, marginTop: '8px' }}>Pek çok işlem aynı gün içinde tamamlanır. Parça tedariğine bağlı olarak süre değişebilir.</p>
          </details>
          <details style={{ padding: '10px 0', borderTop: `1px solid ${APPLE_THEME.lightMetalicGray}` }}>
            <summary style={{ cursor: 'pointer', color: APPLE_THEME.black, fontFamily: TYPOGRAPHY.hero, fontSize: '16px' }}>Orijinal parça kullanıyor musunuz?</summary>
            <p style={{ color: APPLE_THEME.textGray, fontFamily: TYPOGRAPHY.body, marginTop: '8px' }}>Onaylı ve yüksek kalite parçalar kullanıyoruz. Garanti kapsamı bilgisi için bize ulaşın.</p>
          </details>
          <details style={{ padding: '10px 0', borderTop: `1px solid ${APPLE_THEME.lightMetalicGray}` }}>
            <summary style={{ cursor: 'pointer', color: APPLE_THEME.black, fontFamily: TYPOGRAPHY.hero, fontSize: '16px' }}>Verilerim güvende mi?</summary>
            <p style={{ color: APPLE_THEME.textGray, fontFamily: TYPOGRAPHY.body, marginTop: '8px' }}>KVKK uyumlu süreçlerle çalışıyoruz. İşlem öncesi yedekleme konusunda yardımcı oluyoruz.</p>
          </details>
        </div>

    <div style={{ textAlign: 'center', marginTop: '28px' }}>
          <p style={{ color: APPLE_THEME.metalicGray, fontFamily: TYPOGRAPHY.body, marginBottom: '10px' }}>Çözüm bulamadınız mı?</p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="/iletisim" style={{ padding: '10px 16px', borderRadius: '999px', border: `1px solid ${APPLE_THEME.lightMetalicGray}`, color: APPLE_THEME.black, fontFamily: TYPOGRAPHY.body, textDecoration: 'none' }}>Bize yazın</a>
      <a href="tel:+905382477373" style={{ padding: '10px 16px', borderRadius: '999px', background: APPLE_THEME.darkMetalicGray, color: APPLE_THEME.white, fontFamily: TYPOGRAPHY.body, textDecoration: 'none' }}>Bizi arayın</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Support;
